/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Image_Inspector_Color_SpaceInputs */

const en_image_inspector_color_space = /** @type {(inputs: Image_Inspector_Color_SpaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Color space`)
};

const ar_image_inspector_color_space = /** @type {(inputs: Image_Inspector_Color_SpaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`فضاء اللون`)
};

const bn_image_inspector_color_space = /** @type {(inputs: Image_Inspector_Color_SpaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`কালার স্পেস`)
};

const de_image_inspector_color_space = /** @type {(inputs: Image_Inspector_Color_SpaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Farbraum`)
};

const es_image_inspector_color_space = /** @type {(inputs: Image_Inspector_Color_SpaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Espacio de color`)
};

const fr_image_inspector_color_space = /** @type {(inputs: Image_Inspector_Color_SpaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Espace colorimétrique`)
};

const pt_image_inspector_color_space = /** @type {(inputs: Image_Inspector_Color_SpaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Espaço de cor`)
};

const zh_image_inspector_color_space = /** @type {(inputs: Image_Inspector_Color_SpaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`色彩空间`)
};

const tr_image_inspector_color_space = /** @type {(inputs: Image_Inspector_Color_SpaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Renk uzayı`)
};

const ru_image_inspector_color_space = /** @type {(inputs: Image_Inspector_Color_SpaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Цветовое пространство`)
};

const pl_image_inspector_color_space = /** @type {(inputs: Image_Inspector_Color_SpaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Przestrzeń kolorów`)
};

/**
* | output |
* | --- |
* | "Color space" |
*
* @param {Image_Inspector_Color_SpaceInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const image_inspector_color_space = /** @type {((inputs?: Image_Inspector_Color_SpaceInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Inspector_Color_SpaceInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_image_inspector_color_space(inputs)
	if (locale === "bn") return bn_image_inspector_color_space(inputs)
	if (locale === "de") return de_image_inspector_color_space(inputs)
	if (locale === "es") return es_image_inspector_color_space(inputs)
	if (locale === "fr") return fr_image_inspector_color_space(inputs)
	if (locale === "pt") return pt_image_inspector_color_space(inputs)
	if (locale === "zh") return zh_image_inspector_color_space(inputs)
	if (locale === "tr") return tr_image_inspector_color_space(inputs)
	if (locale === "ru") return ru_image_inspector_color_space(inputs)
	if (locale === "pl") return pl_image_inspector_color_space(inputs)
	return en_image_inspector_color_space(inputs)
});